// extracted by mini-css-extract-plugin
export var section = "_1d-1";
export var topNav = "_1d-0";